<template>
  <div v-if="useWrapper" :class="`form-ant-textarea-wrapper${wrapperClass ? ` ${wrapperClass}` : ''}`" data-type="textarea">
    <a-textarea v-bind="$attrs" :value="_value" @update:value="returnValue" />
  </div>
  <a-textarea v-else v-bind="$attrs" :value="_value" @update:value="returnValue" />
</template>

<script>
export default {
  name: 'FormAntdTextarea',
  inheritAttrs: false,
  components: {},
  props: {
    /**
     * Value bound via v-model.
     */
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: ''
    },
    /**
     * Use Wrapper.
     */
    useWrapper: {
      type: Boolean,
      default: false
    },
    /**
     * Additional classes for the wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    _value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.returnValue(value)
      }
    }
  },
  methods: {
    returnValue(value) {
      // emit updateModel value
      this.$emit('update:modelValue', value)
      if (this.$attrs.onUpdateModelValue && typeof this.$attrs.onUpdateModelValue === 'function') {
        this.$attrs.onUpdateModelValue(value)
      }
    }
  }
}
</script>

<style lang="postcss" scoped></style>
